var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M16.372 62.564l3.29 3.29a2.56 2.56 0 003.581.04l1.767-1.691a1.298 1.298 0 00.02-1.85s0 0 0 0a.773.773 0 01.012-1.109l1.229-1.177a1 1 0 01.978-.236l14.872 4.455a5.935 5.935 0 004.368-.381l22.93-11.51a3.662 3.662 0 001.583-5.01l-.001-.003a3.63 3.63 0 00-4.761-1.555l-11.329 5.41m-18.645 3.892l7.296 2.242a3.558 3.558 0 004.446-2.355l.001-.002a3.561 3.561 0 00-2.363-4.449l-6.568-2.003m1.317-9.64a22.335 22.335 0 012.523-.143c.109 0 .318-.009.587-.009.243 0 .546.009.643.009 4.682 0 9.01 1.473 12.512 3.746l.041.027"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.533,
    cy: 21.14,
    r: 11.838,
    fill: "none",
    className: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M12.939 29.176h9.378v8.917h9.379v8.917h-9.379v8.917h-9.378V47.01H3.561v-8.917h9.378v-8.917z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.3a8b0d66b9e7773932fe09f32eec37da.svg";
export { ForwardRef as ReactComponent };